import axiosInstance from "@/lib/axios";

export const productService = {
    getProducts: async ({ page = 1, dateFilter = 'today' }) => {
      const response =await axiosInstance.get(`/api/v1/admin/products?page=${page}&date_filter=${dateFilter}`);
      
      return response.data;
    },
    
    deleteProduct: async (id) => {
      const response = await axiosInstance.delete(`/api/v1/admin/products/${id}`);
      
      return response.data;
    }
  };